var _path, _ellipse;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenDoorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.31,86.27H77.7V31.09A6.13,6.13,0,0,0,71.58,25H60.12a6.35,6.35,0,0,0-1.59.21V20.67a5.67,5.67,0,0,0-7.25-5.44l-26,7.52a5.84,5.84,0,0,0-4.21,5.59V86.27H4.2a2.12,2.12,0,1,0,0,4.23H94.31a2.12,2.12,0,1,0,0-4.23ZM60.12,29.48H71.58a1.62,1.62,0,0,1,1.61,1.61V85H58.53V30.88A1.6,1.6,0,0,1,60.12,29.48ZM25.67,28.34a1.29,1.29,0,0,1,.91-1.22l26-7.52A1.11,1.11,0,0,1,54,20.67V85.13H25.67Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.37,
    cy: 52.27,
    rx: 3.9,
    ry: 5.04
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenDoorIcon);
export default __webpack_public_path__ + "static/media/open-door-icon.2f8eeb21cc600f7f68ab679606e1e42c.svg";
export { ForwardRef as ReactComponent };